<template>

    <aside>
        <div class="wufoo-ad-wrap" :id="variant">
            <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1370.42836 1370.3273"
            >
                <defs>
                </defs>
                <title>Recurso 3</title>
                <g id="Capa 2" data-name="Capa 2">
                    <g id="icons">
                        <path
                                id="roundMain"
                                class="cls-1"
                                d="M1370.32422,685.16211c0,370.91285-294.72248,673.00082-662.79157,684.78561a.04744.04744,0,0,1-.06851,0c-.89072.03426-1.74717.06852-2.63788.10277-.34258,0-.68516.03392-1.02808.03392-.61631,0-1.23261.0346-1.88386.0346a3.30646,3.30646,0,0,1-.58239,0,6.33176,6.33176,0,0,1-.78793.03426c-.06852.03426-.13738,0-.20589,0-.582,0-1.19835.03426-1.78108.03426-4.45321.10277-8.90711.13669-13.39492.13669a682.56462,682.56462,0,0,1-409.52174-135.79879A687.63665,687.63665,0,0,1,52.518,948.70971,683.48237,683.48237,0,0,1,0,685.16211C0,306.74742,306.74708,0,685.16211,0c4.45355,0,8.90745.06886,13.3264.13738.54813,0,1.09592.03425,1.64439.03425h.308a7.22571,7.22571,0,0,1,.85645.03392h.617c.58239,0,1.199.0346,1.78142.0346.4111,0,.78794.03426,1.16478.03426q1.54161.05139,3.08323.10277h.37684a684.64047,684.64047,0,0,1,662.00363,684.78493Z"
                        />
                        <path
                                id="borderShadow"
                                class="cls-2"
                                d="M1316.77914,419.21644A684.49526,684.49526,0,0,0,708.32059.37718h-.37684q-1.5411-.05139-3.08323-.10277C335.2159,10.24352,38.57463,313.05091,38.57463,685.16211c0,372.07762,296.607,674.88468,666.25163,684.88838.89071-.03425,1.74716-.06851,2.63788-.10277a.04744.04744,0,0,0,.06851,0c368.06909-11.78479,662.79157-313.87276,662.79157-684.78561A682.5742,682.5742,0,0,0,1316.77914,419.21644Zm-65.63921,488.69221A574.81112,574.81112,0,1,1,1296.053,685.16211,569.8958,569.8958,0,0,1,1251.13993,907.90865Z"
                        />
                        <g id="abvGroup">
                            <text
                                    id="abvShadow"
                                    class="cls-3"
                                    transform="translate(264.90326 830.18996)"
                            >
                                {{abv}}
                            </text>
                            <text
                                    id="abvNormal"
                                    class="cls-4"
                                    transform="translate(225.73773 830.25734)"
                            >
                                {{abv}}
                            </text>
                        </g>
                        <path
                                id="borderNormal"
                                class="cls-5"
                                d="M685.26625,112.85339A572.49234,572.49234,0,0,1,908.00149,1212.54817,572.48947,572.48947,0,0,1,462.531,157.78187a568.6281,568.6281,0,0,1,222.73524-44.92848m0-112.85031C306.86184.00308.10414,306.76044.10414,685.16519s306.7577,685.16211,685.16211,685.16211c378.4051,0,685.16211-306.75735,685.16211-685.16211S1063.67135.00308,685.26625.00308Z"
                        />
                        <g id="bright" class="cls-6">
                            <path
                                    class="cls-7"
                                    d="M1336.025,470.52754l-91.709,91.70929L835.47982,971.07272l-64.81633,64.78242L562.20292,1244.31537l-91.70861,91.70895q-26.10519-8.58114-51.25047-19.21846a683.25923,683.25923,0,0,1-143.57572-82.25371,690.66162,690.66162,0,0,1-62.69267-52.89486,680.40073,680.40073,0,0,1-57.24495-61.59573l80.19822-80.19856L452.54306,823.24934,620.81853,654.97352l71.77039-71.80533L828.55969,447.19777,1039.82942,235.963l80.23249-80.26674A684.46532,684.46532,0,0,1,1234.51858,275.702a681.61987,681.61987,0,0,1,82.288,143.54146Q1327.39127,444.4227,1336.025,470.52754Z"
                            />
                            <path
                                    class="cls-7"
                                    d="M998.06913,75.49767l-84.65177,84.68638L741.09909,332.46738,418.6272,654.97352,160.14979,913.45059,75.498,998.10236q-12.43569-24.15195-22.95259-49.36558a679.04649,679.04649,0,0,1-32.27182-97.6356l96.711-96.74489,637.40631-637.372L851.10118,20.2736a674.77715,674.77715,0,0,1,97.6356,32.27114Q973.9175,63.07911,998.06913,75.49767Z"
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    </aside>

</template>

<script>
  export default {
    name: 'CoinAvatar',
    props: {
      abv: {
        type: String,
        required: true,
        default : 'USD'
      },
      variant: {
        type: String,
        default: 'silver'
      },
    },
  }
</script>

<style scoped>

    .cls-1 {
        fill: #adb5bd;
    }

    .cls-2,
    .cls-3 {
        fill: #83898e;
    }

    .cls-3,
    .cls-4 {
        font-size: 410.69958px;
        font-weight: bold;
        font-family: Montserrat-Regular, Montserrat;
    }

    .cls-4,
    .cls-5 {
        fill: #dee2e6;
    }

    .cls-6 {
        opacity: 0.2;
    }

    .cls-7 {
        fill: #fff;
    }

    aside {
        width: 60%;
        margin: 5px;
        /*min-width: 100px;*/
        /*max-width: 100px;*/
        /*margin: 25px auto;*/
    }

    .wufoo-ad-wrap {
        /*height: 0;*/
        /*padding-top: 70%;*/
        /*position: relative;*/
    }

    #gold #borderNormal, #gold #abvNormal {
        fill: #ffbf69 !important;
    }

    #gold #abvShadow, #gold #borderShadow {
        fill: #ce7819 !important;
    }

    #gold #roundMain {
        fill: #ff9f1c !important;
    }


    #silver #borderNormal, #silver #abvNormal {
        fill: #dee2e6 !important;
    }

    #silver #abvShadow, #silver #borderShadow {
        fill: #83898e !important;
    }

    #silver #roundMain {
        fill: #adb5bd !important;
    }

</style>